import { HashRouter as Router } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { Tooltip } from 'react-tooltip'
import "react-toastify/dist/ReactToastify.css";
import 'react-tooltip/dist/react-tooltip.css'

import Provider from "../context";
import Routes from "./routes";
import Spinner from "../component/spinner";
import PrivilegesContainerProvider from "src/context/privileges";

const App = () => {
  return (
    <>
      <Tooltip id="my-tooltip" />
      <Router>
        <Provider>
          <PrivilegesContainerProvider>
            <Routes />
          </PrivilegesContainerProvider>
          <Spinner />
        </Provider>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
